import React from "react"
import { CheckmarkCircle, StandardBox, StandardButton, StandardButtonWithSpinner } from "swiipe.portal.shared"
import { ClearhausOnboardingFooter } from "../clearhaus/ClearhausOnboardingFooter"
import "./KycOnboardingMessage.scss"

interface IKycOnboardingMessage {
    mainText: React.ReactNode
    secondaryText?: React.ReactNode
    checkmarkHidden?: boolean
    mainButton: {
        text: string
        onClick: () => void | Promise<void>
    }
    leftButton?: {
        text: string
        onClick: () => void
    }
}

const KycOnboardingMessage = ({ mainText, secondaryText, checkmarkHidden, mainButton, leftButton }: IKycOnboardingMessage) => {
    return (
        <div className="kyc-onboarding-message">
            <StandardBox className="mt-2" padding="35-20" margin="0" borders="rounded">
                <div className="kyc-onboarding-message__main-message">
                    <div className="kyc-onboarding-message__circle">
                        {!checkmarkHidden && <CheckmarkCircle size="big" checked={true} />}
                    </div>
                    <div className="kyc-onboarding-message__text">{mainText}</div>
                </div>
                {secondaryText && (
                    <div className="kyc-onboarding-message__message-after-underline">
                        <hr />
                        <div className="content">{secondaryText}</div>
                    </div>
                )}
            </StandardBox>
            <ClearhausOnboardingFooter
                left={
                    leftButton && (
                        <StandardButton className="kyc-onboarding-message__left-button" inverted onClick={leftButton.onClick}>
                            {leftButton.text}
                        </StandardButton>
                    )
                }
                middle={
                    <StandardButtonWithSpinner
                        className="kyc-onboarding-message__main-button"
                        onClick={async (setShowSpinner) => {
                            setShowSpinner(true)
                            await mainButton.onClick()
                            setShowSpinner(false)
                        }}
                        dark
                        isPurple
                        noBorder
                    >
                        {mainButton.text}
                    </StandardButtonWithSpinner>
                }
            />
        </div>
    )
}

export default KycOnboardingMessage
